
 <!-- STAGE and STAGE UPDATE -->
<div class="loader" *ngIf="loadingNextStages">
  <div class="dimmed">
    <div class="dimmed_flex">
      <div class="dimmed_status_box">
      </div>
      <div class="dimmed_status_box">
      </div>
    </div>
  </div>
</div>

<article class="project-details-stages" *ngIf="!loadingNextStages">

    <div class="project-stage project-stage-one" [style.background-color]="project.status.color">
      <div class="project-stage-first">
        <h4 class="ng-binding"> <em>{{project.status.name}}</em> <strong></strong></h4>
        <span class="project-stage-arrow-top"></span>
        <span class="project-stage-arrow-bottom"></span>
      </div>
    </div>

    <div class="project-stage project-stage-two" [ngClass]="{'stage-update-active': showNextStages }">
      <div [hidden]="!accessUpdateStage || nextStages !=null && nextStages.length == 0" class="project-stage-step" (click)="openNextStages()">
        <div class="project-stage-none-content"><h4><em>Next Stage</em> <strong></strong></h4></div>
        <core-helpers-box-loading [hidden]="!loadingNextStages"></core-helpers-box-loading>
      </div>
      <div [hidden]="nextStages == null || (nextStages != null && nextStages.length > 0 && accessUpdateStage)" class="project-stage-step" >
        <div class="project-stage-none-content stage-none"><h4><em>N/A</em></h4></div>
          <core-helpers-box-alert-message-icon
            [text]="'You cannot move this project any further'"
            [icon]="'stop_move'"
          ></core-helpers-box-alert-message-icon>
      </div>
      <div class="project-stage-fake-combo" [hidden]="!showNextStages || (nextStages !=null && nextStages.length == 0)">
        <div class="project-stage-fake-combo-item" *ngFor="let stage of nextStages">
            <h4 class="" (click)="updateStage(stage)"><em>{{stage.name}}</em></h4>
            <!-- <h4 class="" [style.color]="stage.color" (click)="updateStage(stage)"><em>{{stage.name}}</em></h4> -->
        </div>
      </div>
    </div>

</article>
<!-- END STAGE and STAGE UPDATE -->

